import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    lastError: null,
    error: null
};

export const callTypes = {
    list: "list",
    action: "action",
};

export const fiaSlice = createSlice({
    name: "fia",
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },

        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        AllFiaRequests: (state, action) => {
            state.actionsLoading = false;
            state.hrms_fia_requests = action.payload.hrms_fia_requests;
            state.totalItems = action.payload.totalItems;
            state.error = null;
        },
        AllFilteredFiaRequests: (state, action) => {
            state.actionsLoading = false;
            state.hrms_fia_requests_filtered = action.payload.hrms_fia_requests;
            state.totalItems_filtered = action.payload.totalItems;
            state.error = null;
        },
        getAllRequestsByUserId: (state, action) => {
            state.actionsLoading = false;
            state.hrms_fia_requests_by_user_id = action.payload.hrms_fia_requests;
            state.totalItems_by_user_id = action.payload.totalItems;
            state.error = null;
        }
    },
});
